import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
    const container = document.querySelector(".snap-sections");
    if (!container) return;

    const proximityFactor = 0.35;
    const media = gsap.matchMedia();

    media.add(
        "(min-width: 992px) and (prefers-reduced-motion: no-preference)",
        function () {
            const sections = Array.prototype.slice
                .call(container.querySelectorAll(":scope > section"))
                .filter(function (section) {
                    return section.offsetParent !== null;
                });

            if (sections.length === 0) return;

            let points = [];

            const measure = function () {
                const max = ScrollTrigger.maxScroll(window);
                if (max <= 0) {
                    points = [];
                    return;
                }

                const tops = sections.map(function (section) {
                    return (
                        section.getBoundingClientRect().top +
                        window.scrollY -
                        $.constants.menuHeight
                    );
                });

                points = tops
                    .filter(function (top) {
                        return top >= 0 && top <= max;
                    })
                    .map(function (top) {
                        return top / max;
                    })
                    .sort(function (a, b) {
                        return a - b;
                    });
            };

            const insidePinnedSection = function (scroll) {
                return ScrollTrigger.getAll().some(function (trigger) {
                    if (!trigger.pin) return false;
                    return scroll > trigger.start + 1 && scroll < trigger.end - 1;
                });
            };

            const snapTo = function (progress) {
                if (points.length === 0) return progress;

                const max = ScrollTrigger.maxScroll(window);
                if (max <= 0) return progress;

                if (insidePinnedSection(progress * max)) return progress;

                let nearest = points[0];
                points.forEach(function (point) {
                    if (Math.abs(point - progress) < Math.abs(nearest - progress))
                        nearest = point;
                });

                const travel = Math.abs(nearest - progress) * max;
                if (travel > window.innerHeight * proximityFactor) return progress;

                return nearest;
            };

            const trigger = ScrollTrigger.create({
                start: 0,
                end: "max",
                invalidateOnRefresh: true,
                refreshPriority: -1000,
                onRefresh: measure,
                snap: {
                    snapTo: snapTo,
                    duration: { min: 0.15, max: 0.4 },
                    delay: 0.08,
                    ease: "power1.inOut",
                },
            });

            measure();

            return function () {
                trigger.kill();
            };
        },
    );
});
